import { Injectable, inject } from '@angular/core';
import { EnvService } from '@lib/env';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IProcessInstance } from '@lib/workflow-util';
import { HttpExtras } from '@lib/core';
import { IRecord } from '@lib/util';
import { ITaskBasePreview, ITaskListPreview, TaskAdapter } from '@lib/workflow-integration';
import { UriBuilder } from 'uribuilder';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class PurchaseRequisitionWorkflowDataService {
    private readonly env = inject(EnvService);
    private readonly http = inject(HttpClient);


    public getProcessesFor(purchaseRequisitionId: string): Observable<IProcessInstance[]> {
        return this.http.get<IProcessInstance[]>(
            this.env.getBase('purchase-requisition', purchaseRequisitionId, 'process').toString(),
            {
                params: HttpExtras.IGNORE_CACHE,
            }
        );
    }

    public getProcessBpmnXmlForPurchaseRequisition(
        processInstanceId: IProcessInstance,
        purchaseRequisitionId: string
    ): Observable<IRecord<string>> {
        return this.http.get<IRecord<string>>(
            this.env
                .getBase(
                    'purchase-requisition',
                    purchaseRequisitionId,
                    'process',
                    processInstanceId.definitionId,
                    'bpmn'
                )
                .toString()
        );
    }

    public getAllTasksForDemand(demandId: string): Observable<ITaskListPreview[]> {
        const uri: UriBuilder = this.env.getBase('demand', demandId, 'task');

        return this.http
            .get<ITaskBasePreview[]>(uri.toString(), {
                params: new HttpExtras({
                    ignoreCache: true,
                    customErrorhandling: true,
                }),
            })
            .pipe(
                map((data: ITaskBasePreview[]) => {
                    data.forEach(
                        (task: ITaskBasePreview) =>
                            (task.formKey = task.formKey.replace(EnvService.workflowFormKeyPrefix, ''))
                    );

                    return data.map((task: ITaskBasePreview) => TaskAdapter.getInstanceOfTaskPreview(task));
                })
            );
    }
}
